import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../bmr/services/api/axios.config";
import { notify } from "../../../bmr/utils/methods/notification";

const initialState = {
  isLoading: false,
  roles: [],
  assignedPermission: [],
}
// Fetch all the roled listing
export const fetchRoles = createAsyncThunk(
  'bmr/fetchRoles',
  async ( params,{ rejectWithValue } ) => {
    try {
      const response = await api.get('/acl/roles',{params: params});
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

// Add roles to the permission of the form template
export const assignPermission = createAsyncThunk(
  'bmr/assignPermission',
  async (args, { rejectWithValue }) => {
    try {
      const response = await api.post('/ftb/permissions/assign', args);
      notify.success(response.data.message);
    } catch (error) {
      notify.error(error || error.message);
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

// Fetch all the roled listing
export const fetchedAssignedPermissions = createAsyncThunk(
  'bmr/fetchedAssignedPermissions',
  async (params,{ rejectWithValue }) => {
    try {
      const response = await api.get(`ftb/templates/${params?.id}/permissions`,{params: params});
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

//Remove the permission from the listing 
export const removeAssignedPermission = createAsyncThunk(
  'bmr/removeAssignedPermission',
  async (args, { rejectWithValue }) => {
    try {
      const response = await api.delete(`ftb/permissions/remove`, {data:args});
      notify.success(response.data.message);
      return response.data;
    } catch (error) {
      notify.error(error?.message || error);
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

const bmrFbPermissionSlices = createSlice({
  name: 'bmrFbPermission',
  initialState,
  extraReducers: (builder) => {
    builder
      //@info created slice to fetched roles

      .addCase(fetchRoles.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.isLoading = false;
        state.roles = action.payload.data;
      })
      .addCase(fetchRoles.rejected, (state) => {
        state.isLoading = false;
      })
      //@info created slice to post assigned permission

      .addCase(assignPermission.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(assignPermission.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(assignPermission.rejected, (state) => {
        state.isLoading = false;
      })
      //@info created slice to fetched assigned permission
      .addCase(fetchedAssignedPermissions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchedAssignedPermissions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.assignedPermission = action.payload.data
      })
      .addCase(fetchedAssignedPermissions.rejected, (state) => {
        state.isLoading = false;
      })
      //@info Remove assigned permission from the listing
      .addCase(removeAssignedPermission.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(removeAssignedPermission.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(removeAssignedPermission.rejected, (state) => {
        state.isLoading = false;
      })
  }
});

export default bmrFbPermissionSlices.reducer;
